export const INACTIVE_TAB_INDEX = -1;
export const DEFAULT_TAB_INDEX = 0;

export const STORAGE_KEYS = {
  AWN_ORGANIZATION: 'AWN_SELECTED_ORGANIZATION',
  AWN_PREVIOUS_PAGE_URL: 'AWN_PREVIOUS_PAGE_URL',
  DEBUG_QB: 'DEBUG_QB',
};

export const DEBOUNCE_TIME_SHORT = 200;
export const DEBOUNCE_TIME_MEDIUM = 450;
export const DEBOUNCE_TIME_LONG = 1000;

export const PAGE_TOP_MARGIN = '1.5rem';
export const LEFT_MENU_WIDTH = '16rem';

export const FLAG_MANAGER = 'FLAG_MANAGER';

export const enum EventKey {
  Tab = 'Tab',
  Left = 'ArrowLeft',
  Up = 'ArrowUp',
  Right = 'ArrowRight',
  Down = 'ArrowDown',
  Shift = 'Shift',
  Return = 'Enter',
  Esc = 'Escape',
}

export const TIMEZONE_UTC = 'utc';
export const TIMEZONE_LOCAL = 'local';
export const STORE_DURATION = '{{duration}}';
export const DATE_REGEX =
  /\b\d{4}-\d{2}-\d{2}(?:T\d{2}:\d{2}:\d{2}(?:\.\d+)?Z)?\b/i;

/** @deprecated Use constants from @platform/core/state instead */
export const TWENTY_FOUR_H_IN_MS = 1000 * 60 * 60 * 24;
/** @deprecated Use constants from @platform/core/state instead */
export const SECOND_IN_MS = 1000;
/** @deprecated Use constants from @platform/core/state instead */
export const MINUTE_IN_MS = 60 * SECOND_IN_MS;

export const IPV4_REGEX = /^(\d{1,3}\.){3}\d{1,3}$/;

export const EMPTY_FIELD_FALLBACK = '--';
